export enum BebopOperationsImportStatus {
    Imported = 1,
    ExpenseNoteReadOnly = 2
}